import {
  ApolloClient,
  IntrospectionFragmentMatcher,
} from 'apollo-client';
import { createNetworkInterface } from './network-interface';
import authenticator from './middlewares/authenticator';
import errorHandler from './afterwares/error-handler';
import loaderAfterware from './afterwares/loader';
import loaderMiddleware from './middlewares/loader';
import types from './typemap.json';

// Use a custom fragment matcher to tell Apollo how interface and union types
// used in fragments resolve to implemented types.
//
// Check the link for more details:
// http://dev.apollodata.com/react/initialization.html#fragment-matcher
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: { types },
  },
});

// Define a the GraphQL endpoint and register middlewares and afterwares.
const networkInterface = createNetworkInterface({
  uri: '/internal-api',
  transportBatching: true,
  opts: {
    headers: {},
  },
});
networkInterface.use([loaderMiddleware, authenticator]);
networkInterface.useAfter([loaderAfterware, errorHandler]);

// Build the Apollo client.
export default new ApolloClient({
  networkInterface,
  fragmentMatcher,
  connectToDevTools: process.env.NODE_ENV !== 'prod',
});



// WEBPACK FOOTER //
// ./api/client.js